import {Component} from "@angular/core";
import {FontAwesomeService} from "@services/font-awesome.service";

@Component({
  selector: 'app-search-failure-header',
  template: `
    <app-card-wrapper [failure]="true" [leftPanel]="true">
      <div class="container">
        <fa-icon [icon]="faService.faExclamationCircle"></fa-icon>
        <div>
          <h4 translate>error.order.searchResult.general.title</h4>
          <p translate>error.order.searchResult.general.message</p>
        </div>

      </div>
    </app-card-wrapper>
  `,
  styleUrls: ['./search-failure-header.component.scss']
})

export class SearchFailureHeaderComponent {
  constructor(public faService: FontAwesomeService) {}

}



// WEBPACK FOOTER //
// ./src/app/modules/consignment/search-results/components/search-failure-header/search-failure-header.component.ts